import "./chartjs-init";
import { App } from "./pages";
import { render } from "./utils/render";

render(App);
